'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import * as React from 'react';
import { findDOMNode } from 'react-dom';
import getComponentName from 'react-utils/getComponentName';
import { callIfPossible } from '../../core/Functions';
export default function (Component) {
  class DraggableComponent extends React.Component {
    render() {
      const _this$props = this.props,
            {
        connectDragSource,
        connectDropTarget
      } = _this$props,
            rest = _objectWithoutPropertiesLoose(_this$props, ["connectDragSource", "connectDropTarget"]);

      return /*#__PURE__*/_jsx(Component, Object.assign({}, rest, {
        ref: instance => {
          // order matters here :/
          callIfPossible(connectDropTarget, findDOMNode(instance));
          callIfPossible(connectDragSource, findDOMNode(instance));
        }
      }));
    }

  }

  DraggableComponent.propTypes = Object.assign({}, Component.propTypes, {
    connectDragSource: PropTypes.func,
    connectDropTarget: PropTypes.func
  });
  DraggableComponent.defaultProps = Component.defaultProps;
  DraggableComponent.displayName = `Draggable(${getComponentName(Component)})`;
  DraggableComponent.WrappedComponent = Component;
  return DraggableComponent;
}